import React from 'react'
import { Column } from 'primereact/column'
import WorkTypeFilterTemplate from '../Filters/WorkTypeFilterTemplate'
import { createColumnAttributes } from '../utils/createColumnAttributes'
import { getRowClassName } from '../utils/getRowClassName'
import { FilterMatchMode } from 'primereact/api'

/**
 * Work Type column component with badge display and dropdown filter
 * Displays work types (TVR, BKS, ART) with aqua badge styling
 */
const WorkTypeColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, template, originalData, style }) => {
    const { filterAttributes, sortAttributes, checkFieldChanged } = createColumnAttributes({
        filter,
        title,
        sortable,
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    // Custom filter attributes for dropdown
    const customFilterAttributes = filter ? {
        filter: true,
        filterElement: (options) => <WorkTypeFilterTemplate options={options} />,
        filterMatchMode: FilterMatchMode.EQUALS,
        showFilterMatchModes: false
    } : filterAttributes

    const defaultTemplate = (rowData) => (
        <span className="p-tag custom-badge-base custom-badge-aqua-3">
            {rowData[mapsToField]}
        </span>
    )

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            style={style}
            body={(rowData) => (
                <span className={getRowClassName(checkFieldChanged, rowData)}>
                    {template ? template(rowData) : defaultTemplate(rowData)}
                </span>
            )}
            {...customFilterAttributes}
        />
    )
}

export default WorkTypeColumn
